import { useTranslations } from "@zapier/i18n";
import {
  HydratedTable,
  useDeleteTable as useDeleteTableMutation,
  useFavoriteAssets,
} from "@zapier/client";
import { AssetTypes, useNotification } from "@zapier/utils";

export function useDeleteTable(
  table: HydratedTable | undefined,
  folderId?: string,
) {
  const t = useTranslations("table-delete-modal");
  const { mutate, isPending } = useDeleteTableMutation({ folderId });
  const { createNotification } = useNotification();

  const { removeFromFavorites } = useFavoriteAssets();

  const deleteTable = () => {
    if (!table) {
      return;
    }

    mutate(
      { id: table.id },
      {
        onSuccess: () => {
          createNotification({
            message: t("notifications.delete-success", {
              tableName: table.name,
            }),
            type: "success",
          });

          removeFromFavorites(table.id, AssetTypes.Table);
        },
        onError: () => {
          createNotification({
            message: t("notifications.delete-error", { tableName: table.name }),
            type: "error",
          });
        },
      },
    );
  };

  return { deleteTable, isPending };
}
